import { useRef, useCallback } from "react";
import html2canvas from "html2canvas";

export function useCaptureImage() {
  const ref = useRef(null);

  const getBase64 = useCallback(async () => {
    if (!ref.current) return null;
    const canvas = await html2canvas(ref.current);
    return canvas.toDataURL("image/png");
  }, []);

  return { ref, getBase64 };
}

export function CaptureWrapper({ children, captureRef }) {
  return <div ref={captureRef}>{children}</div>;
}

// // example
// import React from "react";
// import { useCaptureImage } from "./useCaptureImage";
// import { CaptureWrapper } from "./CaptureWrapper";

// export default function MyComponent() {
//   const { ref, getBase64 } = useCaptureImage();

//   const handleClick = async () => {
//     const base64 = await getBase64();
//     console.log("Base64:", base64);

//     // ตัวอย่าง: แสดงภาพที่แปลง
//     const img = new Image();
//     img.src = base64;
//     document.body.appendChild(img);
//   };

//   return (
//     <div>
//       <CaptureWrapper captureRef={ref}>
//         <div style={{ padding: 20, backgroundColor: "#e0f7fa", border: "1px solid #ccc" }}>
//           <h2>ข้อมูลที่จะแปลงเป็นภาพ</h2>
//           <p>เนื้อหานี้จะถูกแปลงเป็นภาพ base64</p>
//         </div>
//       </CaptureWrapper>

//       <button onClick={handleClick}>แปลงเป็นภาพ</button>
//     </div>
//   );
// }
